var plugin_rtlignore_default = {
  "alignLeft": "gS8ci",
  "textWrapNowrap": "ShETJ",
  "alignRight": "_6wOA5",
  "alignCenter": "JhVFE",
  "sizeFullWidth": "UAJy6",
  "renderedInTable": "I6WYn",
  "sizeOriginal": "_945IE",
  "sizeContent": "LFV3q",
  "sizeSmall": "U9waJ",
  "sizeSmallCenter": "CIlJ-",
  "flex": "IG4h5",
  "atomic": "_1WtRA",
  "embed": "hSR8K",
  "horizontalScrollbar": "-kZ3r",
  "pluginContainerMobile": "_2uDN4"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
